module.exports = {
  common: {
    instagramLink: "https://www.instagram.com/hkwellcome/",
    facebookLink: "https://www.facebook.com/wellcome.supermarket",
    youtubeLink: "https://www.youtube.com/user/Wellcomesupermarket",
    importantSecurityAlert: "重要安全提示:",
    BewareOfPhishingWebsites: "慎防冒充惠康的詐騙網站",
    importantSecurityLink: "https://www.wellcome.com.hk/d/vSObQHEF8NAhB5P.html"
    // importantSecurityLink: "https://uatsuperweb.rta-os.com/wellcome/d/PrbvVgHXhn.html"
  },
  footer: {
    aboutShop: "關於惠康",
    followUs: "關注我們",
    coptyRight: "© 2024 Wellcome / Market Place. The Dairy Farm Company Limited. All rights reserved.",
    ourStory: "關於惠康",
    ourStoryLink: "/zh-hant/about-wellcome",
    corporateResponsibility: "企業責任",
    corporateResponsibilityLink: "/zh-hant/green-initiatives-list",
    storeLocatorLink: "/zh-hant/store_locator",
    careersLink: "/zh-hant/join-us",
    corporatePromotionsLink: "/zh-hant/yuu-rewards-club",
    foodPermitsLink: "/dl/All_Wellcome.com.hk_2024(combined).pdf",
    foodPermitsName: "Wellcome license.pdf",
    tel: "+852 3001 1299",
    emailLink: "contactus@yuurewardsclub.com.hk",
    privacyPolicyLink: "https://www.yuurewards.com/zh-hant/privacy-policy",
    termsAndConditionsLink: "https://www.wellcome.com.hk/zh-hant/d/hcDR1FBqZ4.html",
    wellcomeWhatsAppTermsAndConditions: "惠康 WhatsApp 條款及細則",
    wellcomeWhatsAppTermsAndConditionsLink: "/zh-hant/wellcome-whatsapp-terms-and-conditions",
    contactUsLink: "https://www.yuurewards.com/zh-hant/faq?categoryKey=Wellcome.com.hk",
    appStoreLink: "https://apps.apple.com/tr/app/wellcome-online-shop/id6473398628",
    goolePlayLink: "https://play.google.com/store/apps/details?id=com.rtahk.wellcome&hl=en&gl=US",
    emailBulkorderLink: "Business@Wellcome.com.hk",
    b2bBulkOrdersEnquires: "企業合作及大量訂購查詢"
  },
  page: {
    siteName: "惠康",
    siteUrl: "https://www.wellcome.com.hk",
    title: "惠康官方網店",
    description:
      "惠康為你搜羅過萬款優質超值鮮級食材、糧油雜貨、飲品、美酒、個人護理及生活用品，至抵原箱優惠，最快24小時內極速送貨，$500即免運費，安在家中輕鬆選購。"
  },
  pageTitle: {
    cart: "購物車 | 惠康官方網店",
    checkout: "安全結賬 | 惠康官方網店",
    cards: "電子銀包 | 惠康官方網店",
    coupons: "優惠券 | 惠康官方網店",
    order_list: "我的訂單 | 惠康官方網店",
    order_details: "訂單詳情 | 惠康官方網店",
    cashier: "收銀台 | 惠康官方網店",
    payment: "支付成功 | 惠康官方網店",
    categoryName: "{name} | 惠康官方網店",
    storeLocator: "門店位置 | 惠康官方網店"
  },
  header: {
    feedbackLink: "https://yuu.qualtrics.com/jfe/form/SV_8pm7dSq3GuAuLFc",
    customerCareLink: "https://www.yuurewards.com/zh-hant/faq?categoryKey=Wellcome.com.hk"
  }
}
